/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MoInputs */

const en_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const es_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

const fr_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mois`)
};

const de_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/Mo`)
};

const ja_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const zh_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

const ar_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/شهر`)
};

const id_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/bln`)
};

const it_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mese`)
};

const ru_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/мес`)
};

const pt_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mês`)
};

const ko_mo = /** @type {(inputs: MoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/월`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {MoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mo = /** @type {((inputs?: MoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mo(inputs)
	if (locale === "es") return es_mo(inputs)
	if (locale === "fr") return fr_mo(inputs)
	if (locale === "de") return de_mo(inputs)
	if (locale === "ja") return ja_mo(inputs)
	if (locale === "zh") return zh_mo(inputs)
	if (locale === "ar") return ar_mo(inputs)
	if (locale === "id") return id_mo(inputs)
	if (locale === "it") return it_mo(inputs)
	if (locale === "ru") return ru_mo(inputs)
	if (locale === "pt") return pt_mo(inputs)
	return ko_mo(inputs)
});